<template>
  <div class="container">
    <!-- 加载动画 -->
    <a-spin
      style="position: absolute;left: 0;top: 250px;right: 0;bottom: 0;margin: auto;"
      tip="Loading..."
      v-show="loading"
      size="large"
    >
    </a-spin>
    <!-- 加载动画 end -->
    <!-- 邀约信息 -->
    <a-form-model
      v-show="!loading"
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      v-bind="layout"
    >
      <a-form-model-item :wrapper-col="{ span: 14, offset: 8 }" class="info">
        <h3>转派</h3>
      </a-form-model-item>
      <a-form-model-item label="姓名" class="info">
        <p>{{ detail.name }}</p>
      </a-form-model-item>
      <a-form-model-item label="手机号码" class="info">
        <p>{{ detail.phone }}</p>
      </a-form-model-item>
      <a-form-model-item label="应聘" class="info">
        <p>{{ detail.project_name + "-" + detail.role_name }}</p>
      </a-form-model-item>
      <a-form-model-item label="教育程度" prop="education">
        <a-select v-model="ruleForm.education" style="width:200px">
          <a-select-option :value="1">
            初中及以下
          </a-select-option>
          <a-select-option :value="2">
            中专/高中
          </a-select-option>
          <a-select-option :value="3">
            专科
          </a-select-option>
          <a-select-option :value="4">
            本科
          </a-select-option>
          <a-select-option :value="5">
            硕士及以上
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="工作经历" prop="experienceVal">
        <ul class="experience">
          <li v-for="(item, index) in experienceList" :key="index">
            <a-select
              @change="selectedSkill"
              v-model="item.skill_name"
              placeholder="岗位"
              style="width:30%"
            >
              <a-select-option
                :value="element"
                v-for="(element, j) in skills"
                :key="j"
              >
                {{ element }}
              </a-select-option>
            </a-select>
            <a-select
              v-model="item.proficiency"
              placeholder="年限"
              style="width:30%;margin:0 10px;"
            >
              <a-select-option
                :value="element.id"
                v-for="(element, j) in yearList"
                :key="j"
              >
                {{ element.label }}
              </a-select-option>
            </a-select>
            <a-icon
              v-show="item.type == 'add'"
              style="font-size:24px;color:#67C23A"
              @click="changeExperience(item, index)"
              type="plus-circle"
            />
            <a-icon
              v-show="item.type == 'remove'"
              style="font-size:24px;color:#F56C6C"
              @click="changeExperience(item, index)"
              type="minus-circle"
            />
          </li>
        </ul>
      </a-form-model-item>
      <a-form-model-item label="来源渠道" prop="resume_source_select">
        <a-radio-group v-model="ruleForm.resume_source_select">
          <a-radio :value="1">
            本人
          </a-radio>
          <a-radio :value="2">
            其他
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="其他"
        v-if="ruleForm.resume_source_select == 2"
        prop="resume_third_part_id"
      >
        <a-select style="width:200px" v-model="ruleForm.resume_third_part_id">
          <a-select-option
            :value="element.id"
            v-for="(element, i) in channelList"
            :key="i"
          >
            {{ element.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="面试日期" prop="date">
        <a-date-picker
          @change="interviewDate"
          v-model="ruleForm.date"
          style="width:200px"
          :disabled-date="disabledEndDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="面试时间"
        prop="time"
        v-show="ruleForm.date != ''"
      >
        <a-time-picker
          :value="ruleForm.time == '' ? '' : moment(ruleForm.time, 'HH:mm')"
          @change="interviewTime"
          format="HH:mm"
          style="width:200px"
          :disabledHours="disabledHours"
          :disabledMinutes="disabledMinutes"
        />
      </a-form-model-item>
      <a-form-model-item label="带面人员" prop="manager_user_ids">
        <a-select
          showSearch
          :filterOption="filterOption"
          defaultValue="全部"
          mode="multiple"
          @change="selectedUser"
          style="width: 200px"
          v-model="ruleForm.manager_user_ids"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, z) in userList"
            :key="z"
            >{{ item.user_name }}</a-select-option
          >
        </a-select>
        <span style="margin-left:10px">
          <a-checkbox :checked="checked" @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
        <a-button style="margin-right:10px" @click="resetForm">重置</a-button>
        <a-button type="primary" @click="assignedSure">确定</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      userList: [],
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 }
      },
      ruleForm: {
        resume_source_select: "",
        education: "",
        interview_date: "",
        interview_time: "",
        resume_third_part_id: "",
        time: "",
        date: "",
        manager_user_ids: [],
        experienceVal: ""
      },
      rules: {
        education: [
          {
            required: true,
            message: "请选择教育程度",
            trigger: "change"
          }
        ],
        resume_source_select: [
          {
            required: true,
            message: "请选择来源渠道",
            trigger: "change"
          }
        ],
        resume_third_part_id: [
          {
            required: true,
            message: "请选择其他渠道",
            trigger: "change"
          }
        ],
        manager_user_ids: [
          {
            required: true,
            message: "请选择线下带面人员",
            trigger: "change"
          }
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        time: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        experienceVal: [
          {
            required: true,
            message: "请选择工作经历",
            trigger: "change"
          }
        ]
      },
      detail: "",
      experienceList: [
        {
          skill_name: "",
          proficiency: "",
          type: "add"
        }
      ],
      skills: [
        "配送",
        "服务员",
        "保洁",
        "安保",
        "司机",
        "普工",
        "技工",
        "销售",
        "其他"
      ],
      yearList: [
        // {
        //   label: "无经验",
        //   id: 1
        // },
        {
          label: "小于1年",
          id: 2
        },
        {
          label: "1-3年",
          id: 3
        },
        {
          label: "3-5年",
          id: 4
        },
        {
          label: "大于5年",
          id: 5
        }
      ],
      channelList: [],
      loading: true,
      checked: false
    };
  },
  props: {
    redeployID: null
  },
  watch: {
    redeployID() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.redeployID != null && this.redeployID != undefined) {
      this.getDetail();
    }
    this.getChannelList(); //获取三方渠道
    this.getUser(); //获取指派用户
  },
  methods: {
    moment,
    disabledHours() {
      let hours = [];
      let currentDate = moment().format("YYYY-MM-DD");
      let currentTime = moment().format("HH:mm:ss");
      let currentTimeArr = currentTime.split(":");
      if (moment(this.ruleForm.date).format("YYYY-MM-DD") == currentDate) {
        for (var i = 0; i < parseInt(currentTimeArr[0]); i++) {
          hours.push(i);
        }
      }
      return hours;
      // console.log(currentTime);
    },
    disabledMinutes(selectedHours) {
      let minutes = [];
      let currentTime = moment().format("HH:mm:ss");
      let currentTimeArr = currentTime.split(":");
      let currentDate = moment().format("YYYY-MM-DD");
      if (moment(this.ruleForm.date).format("YYYY-MM-DD") == currentDate) {
        if (selectedHours == parseInt(currentTimeArr[0])) {
          for (var i = 0; i < parseInt(currentTimeArr[1]); i++) {
            minutes.push(i);
          }
        }
      }
      return minutes;
    },
    disabledEndDate(endValue) {
      const startValue = moment().subtract(1, "days");
      console.log(startValue);
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    selectedUser() {
      this.checked = false;
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      this.ruleForm.manager_user_ids = [];
      if (e.target.checked) {
        this.userList.forEach(element => {
          if (this.ruleForm.manager_user_ids.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.ruleForm.manager_user_ids.push(element.id);
          }
          // console.log(element)
        });
      }
    },
    selectedSkill(val) {
      this.ruleForm.experienceVal = val;
    },
    getChannelList() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.detail.project_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.channelList = res.data.data;
            // console.log(this.channelList);
          }
        });
    },
    changeExperience(item, index) {
      if (item.type == "add") {
        // this.skills.splice(this.skills.indexOf(item.post), 1);
        this.experienceList.push({
          skill_name: "",
          proficiency: "",
          type: "remove"
        });
      } else {
        // this.skills.push(item.post);
        this.experienceList.splice(index, 1);
      }
    },
    getDetail() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_task/myAssignResumeTaskDetail";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_task_id: this.redeployID
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            this.ruleForm = {
              education: this.detail.education,
              resume_source_select: this.detail.resume_source_select,
              resume_third_part_id: this.detail.resume_third_part_id,
              experienceVal: this.detail.experienceVal,
              interview_date: this.detail.interview_date,
              interview_time: this.detail.interview_time,
              date: this.detail.interview_date,
              time: this.detail.interview_time,
              manager_user_ids: this.detail.manager_user_id
                .split(",")
                .map(Number)
            };
            this.getUser(); //获取用户
            this.getChannelList(); //获取其他渠道
            // console.log(this.ruleForm.time);
            this.experienceList = [];
            if (this.detail.resume_skill != "") {
              this.detail.resume_skill.forEach((element, index) => {
                if (index == 0) {
                  this.experienceList.push({
                    skill_name: element.skill_name,
                    proficiency: element.proficiency,
                    type: "add"
                  });
                } else {
                  this.experienceList.push({
                    skill_name: element.skill_name,
                    proficiency: element.proficiency,
                    type: "remove"
                  });
                }
              });
              this.ruleForm.experienceVal = "val";
            } else {
              this.experienceList.push({
                skill_name: "",
                proficiency: "",
                type: "add"
              });
            }
            setTimeout(res => {
              this.loading = false;
            }, 150);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUser() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_task/getUserData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        role_names: JSON.stringify([
          "项目经理",
          "项目驻场",
          "项目总监",
          "自招团队"
        ]),
        project_id: this.detail.project_id,
        job_status: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
        }
      });
    },
    interviewDate(data, dataString) {
      this.ruleForm.time = "";
      this.ruleForm.interview_date = dataString;
    },
    interviewTime(time, timeString) {
      this.ruleForm.time = timeString;
      this.ruleForm.interview_time = timeString;
    },
    validation() {
      let fls = true;
      this.experienceList.forEach(element => {
        if (element.skill_name == "") {
          fls = false;
          this.$message.warning("请选择岗位！");
        }
        if (element.proficiency == "") {
          fls = false;
          this.$message.warning("请选择工作时长！");
        }
      });
      return fls;
    },
    assignedSure() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let fls = this.validation();
          if (fls) {
            let resume_skill = [];
            this.experienceList.forEach(element => {
              resume_skill.push({
                skill_name: element.skill_name,
                proficiency: element.proficiency
              });
            });
            let params = {
              token: window.localStorage.getItem("xnwfPcToken"),
              resume_id: this.detail.id,
              resume_task_id: this.detail.id,
              interview_date: this.ruleForm.interview_date,
              interview_time: this.ruleForm.interview_time,
              education: this.ruleForm.education,
              resume_source_select: this.ruleForm.resume_source_select,
              resume_third_part_id: this.ruleForm.resume_third_part_id,
              manager_user_ids: JSON.stringify(this.ruleForm.manager_user_ids),
              resume_skill: JSON.stringify(resume_skill)
            };
            if (this.ruleForm.resume_source_select == 1) {
              delete params.resume_third_part_id;
            }
            let url =
              this.httpsBasic.url +
              this.httpsBasic.resume +
              "Resume_task/transferInvite";
            axios
              .post(url, params)
              .then(res => {
                if (res.data.code == 200) {
                  this.resetForm();
                  this.$message.success("邀约成功");
                  this.$emit("hideIsRedeploy", false);
                } else if (res.data.code == 4222) {
                  this.$info({
                    title: "提示",
                    content: res.data.message,
                    onOk() {}
                  });
                } else {
                  this.$message.warning(res.data.message);
                }
              })
              .catch(err => {
                this.$message.error("服务器出错了...");
              });
          }
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.experienceList = [
        {
          skill_name: "",
          proficiency: "",
          type: "add"
        }
      ];
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding-bottom: 30px;
  .ant-form-item {
    margin-bottom: 10px;
  }
  h3 {
    margin: 30px 0 10px;
    font-weight: normal;
    font-size: 18px;
  }
  .experience {
    > li {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
    }
    > li:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
<style lang="less">
.container {
  .info {
    .ant-form-item-label,
    .ant-form-item-control {
      line-height: 24px;
    }
  }
}
</style>
